import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSearchlinesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSearchlinesSparkle"><Path d="M13.5 21.5H4.5V2.5H19.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 6.5H15.5M8.5 10.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSearchlinesSparkle;
